var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.links),function(link){return _c('li',[_c('router-link',{attrs:{"to":link.to},nativeOn:{"click":function($event){return _vm.$emit('didSelectNavigationLink')}}},[_vm._v(_vm._s(link.title))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }